import { useState } from "react";
import { useTranslation } from "react-i18next";
import { motion } from "framer-motion";
import { getQRCode } from "../../services/ApiCalls";
import Button from "../../Components/Button";
import { FIELD_CLASS } from "../../Components/Input";

const QRCodePage = () => {
  const { t } = useTranslation();
  const [restaurantId, setRestaurantId] = useState("");
  const [qrData, setQrData] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const handleGenerate = async () => {
    const rid = restaurantId.trim();
    if (!rid) {
      setError(t("qrRestaurantIdRequired"));
      return;
    }

    setLoading(true);
    setError("");
    setQrData(null);

    try {
      const data = await getQRCode(rid);
      setQrData(data);
    } catch (err) {
      setError(t("qrGenerationFailed"));
    } finally {
      setLoading(false);
    }
  };

  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ duration: 0.4 }}
      className="flex flex-col items-center justify-center min-h-screen bg-background p-6 text-center gap-6 w-full"
    >
      <div className="flex flex-col gap-2">
        <h1 className="text-xl font-bold text-dark">
          {t("qrPageTitle")}
        </h1>
        <p className="text-muted text-sm">
          {t("qrPageDescription")}
        </p>
      </div>

      <div className="w-full flex flex-col gap-4 max-w-lg">
        <label htmlFor="qr-restaurant-id" className="text-start text-xs font-medium text-muted w-full">
          {t("qrRestaurantIdLabel")}
        </label>
        <input
          id="qr-restaurant-id"
          type="text"
          dir="ltr"
          className={`${FIELD_CLASS} font-mono`}
          placeholder={t("qrRestaurantIdPlaceholder")}
          value={restaurantId}
          onChange={(e) => setRestaurantId(e.target.value)}
        />

        <Button size="lg" fullWidth onClick={handleGenerate} disabled={loading}>
          {loading ? t("qrGenerating") : t("qrGenerate")}
        </Button>
      </div>

      {error && (
        <motion.p
          initial={{ opacity: 0, y: -8 }}
          animate={{ opacity: 1, y: 0 }}
          className="text-danger text-sm font-medium"
        >
          {error}
        </motion.p>
      )}

      {qrData && (
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.3 }}
          className="flex flex-col items-center gap-4"
        >
          <img
            src={qrData.qr}
            alt={t("QR code")}
            className="w-56 h-56 rounded-md border border-border"
          />
          <a
            href={qrData.url}
            target="_blank"
            rel="noopener noreferrer"
            className="text-xs text-primary underline break-all max-w-xs" dir="ltr"
          >
            {qrData.url}
          </a>
        </motion.div>
      )}
    </motion.div>
  );
};

export default QRCodePage;
